/* eslint-disable custom/no-restricted-translation-jsx-untranslated-children-text */
import React from 'react';

import { Typography } from '@mui/material';

import { useIntl } from '@kamernet/core/Intl';
import { Locale } from '@kamernet/core/Intl/types';

import styles from './Content.module.css';

interface ContentStreetAntisquatProps {
  streetName: string;
  cityName: string;
}

export const ContentStreetAntisquat = ({
  streetName,
  cityName,
}: ContentStreetAntisquatProps) => {
  const { locale } = useIntl();

  return locale === Locale.en ? (
    <React.Fragment>
      <Typography
        variant="h1"
        className={styles.title}
      >{`Anti-Squat in ${streetName}, ${cityName}`}</Typography>
      <Typography variant="body1" className={styles.paragraph}>
        {`Living anti-squat in ${streetName} offers flexible living options at an
            affordable price. If you're an expat student searching for a cheap
            housing option, then we have anti-squat homes available in ${streetName} and
            the rest of the ${cityName}. Anti-squatting properties in ${streetName} are very much
            in demand as they are cheaper and provide more flexible living
            options. If you don't know where to find anti squat housing in ${streetName}
            then look no further, as Kamernet is the best website to find
            anti-squat housing near ${streetName} in ${cityName}.`}
      </Typography>
    </React.Fragment>
  ) : (
    <React.Fragment>
      <Typography
        variant="h1"
        className={styles.title}
      >{`Antikraak in ${streetName}, ${cityName}`}</Typography>
      <Typography variant="body1" className={styles.paragraph}>
        {`Wonen anti-kraak in ${streetName} biedt flexibele woonmogelijkheden tegen een
            betaalbare prijs. Als je als expat student op zoek bent naar een
            goedkope woonruimte, dan hebben we antikraak woningen beschikbaar in
            ${streetName} en de rest van de ${cityName}. Antikraak woningen in ${streetName} zijn erg in
            trek omdat ze goedkoper zijn en meer flexibele woonmogelijkheden
            bieden. Weet je niet waar je antikraakwoningen kunt vinden in ${streetName}
            zoek dan niet verder, want Kamernet is de beste website voor het
            vinden van antikraak woningen in de buurt van ${streetName} in ${cityName}.`}
      </Typography>
    </React.Fragment>
  );
};
